export class TerminalOverviewReport {
  public terminalId: number;
  public costCenterId: number;
  public name: string;
  public address: string;
  public city: string;
  public groupId: string;
  public zoneId: number;
  public hardware: string;
  public contractTypeId: number;
  public contractOptions: string;
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-overview-report/terminal-overview-report.type.ts